import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=c7bdb78a"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "./Faq.vue?vue&type=style&index=0&id=c7bdb78a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports